/**
 * Class strings for the console look's form controls (Figma Components ›
 * Input / Button): 36px fields at radius 9.6 on a 1px `line-strong` border that
 * turns ink on focus, and solid-ink primary buttons. Strings rather than
 * components so screens that take a `fieldClass`/`submitClass` prop (the MFA
 * enrolment body) can wear them too.
 *
 * Every value is a console token — these only look right inside `.console`.
 */
export const FIELD_BASE =
  'block h-9 w-full rounded-md border border-line-strong bg-surface px-3 font-dash text-[13px] leading-5 text-ink placeholder:text-muted outline-none transition-shadow duration-150 focus:border-ink focus:shadow-[0_0_0_3px_rgba(20,20,19,0.08)] disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-muted aria-[invalid=true]:border-danger'

/** A field with a leading 16px icon. */
export const FIELD_WITH_ICON = `${FIELD_BASE} pl-[34px]`

export const SUBMIT_FULL =
  'inline-flex h-10 w-full items-center justify-center gap-2 rounded-md border border-primary bg-primary px-4 font-dash text-[13px] font-medium text-primary-ink shadow-[0_1px_1px_rgba(0,0,0,0.06)] transition-colors duration-150 enabled:hover:bg-primary-deep disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-canvas'

export const LINK_QUIET =
  'rounded-sm font-dash text-[12.5px] font-medium text-ink underline decoration-line-strong underline-offset-4 transition-colors duration-150 hover:decoration-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink'

export const LABEL = 'block font-dash text-[13px] font-medium leading-4 text-ink'

/** `aria-describedby` for a control inside `Field`, matching the ids it renders. */
export function describedBy(id: string, error: unknown, hint: unknown): string | undefined {
  if (error) return `${id}-error`
  if (hint) return `${id}-hint`
  return undefined
}
